import { ArticleContentDto } from './articleContent.dto';
import { TagDto } from '../tags/tag.dto';

export interface QuotaDto {
  counter: number;
  limit: number;
  usageIncreased: boolean;
  usageExceeded: boolean;
}

export interface ArticleDto {
  id: number;
  publishDate: string;
  modifiedDate: string;
  analysts: string[];
  content: ArticleContentDto;
  focusTags: TagDto[];
  tags: TagDto[];
  imageCount: number;
  wordCount: number;
  canAccess: boolean;
  quota: QuotaDto | null;
  accessStatus: AccessStatus;
}

export enum AccessStatus {
  granted = 'granted',
  subscriptionRequired = 'subscriptionRequired',
  privateAccessRequired = 'privateAccessRequired',
  quotaExceeded = 'quotaExceeded',
  quotaUsageConfirmRequired = 'quotaUsageConfirmRequired',
  loanWaiverConfirmRequired = 'loanWaiverConfirmRequired',
}
